import React, { useEffect } from 'react'
import PageHeader from '../../components/pageHeader/PageHeader';
import { Form, Input, Checkbox, Button, Row, Col } from 'antd';
import usePost from '../../services/usePost';

const { TextArea } = Input;

const Contact = () => {
  const [form] = Form.useForm();
  const [isPostLoading, postError, postData] = usePost();

  const onFinish = async(values) => {
   const dataToSent = {
      address: values.address,
      createdAt:new Date().toISOString(),
      email: values.email,
      firstName: values.firstName,
      hasRead: 0,
      lastName: values.lastName,
      message: values.message,
      phone: values.phone,
      replied: 0,
      updatedAt: new Date().toISOString()
   }

    const response = await postData('contacts',dataToSent,true)

    if(response){
      form.resetFields()
    }

  };

  useEffect(() => {
   window.scrollTo({
      top:0
   })
  })
  return (
    <div>
       <PageHeader title={'Contact us'}/>
       <div className='contact_page'>
        
        <div className='heading'>
            <h2>Contact us</h2>
            <p className='light_grey'>Connect with us to experience seamless communication. we value open dialogue and are eager to engage with you. whether you have questions, ideas, or feedback, we are here to listen and respond.</p>
        </div>

        <div className='contact_info'>
          <div className='left'>
            <img src='https://static.vecteezy.com/vite/assets/photo-masthead-375-BoK_p8LG.webp' alt='contact_image'/>
            <div>
                <div className='details'>
                    <span>Email:</span>
                   <span className='light_grey'>admin@example.com</span>
                </div>
                <div className='details'>
                    <span>Our address:</span>
                   <span className='light_grey'>455 Wolff Streets Suite 674 </span>
                </div>
                <div className='details'>
                    <span>Get in touch:</span>
                   <span className='light_grey'>345-444-2122  </span>
                </div>
                <div className='details'>
                    <span>Office hours:</span>
                   <span className='light_grey'>0:00 AM - 6:00 PM  </span>
                </div>
            </div>
          </div>
         
         <div className="right">
            <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            >
        
            <Row gutter={16}>
               <Col xs={24} md={12}>
                  <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[{ required: true, message: 'Please enter your first name' }]}
                  >
                  <Input placeholder="First name" />
                  </Form.Item>
               </Col>
               <Col xs={24} md={12}>
                  <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[{ required: true, message: 'Please enter your last name' }]}
                  >
                  <Input placeholder="Last name" />
                  </Form.Item>
               </Col>
            </Row>

            <Row gutter={16}>
               <Col xs={24} md={12}>
                  <Form.Item
                  label="Email Address"
                  name="email"
                  rules={[{ required: true, message: 'Please enter your email' }]}
                  >
                  <Input placeholder="Email address" />
                  </Form.Item>
               </Col>
               <Col xs={24} md={12}>
                  <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[{ required: true, message: 'Please enter your phone number' }]}
                  >
                  <Input placeholder="Phone" />
                  </Form.Item>
               </Col>
            </Row>

    
            <Form.Item
               label="Address"
               name="address"
               rules={[{ required: true, message: 'Please enter your address' }]}
            >
               <Input placeholder="Address" />
            </Form.Item>

      
            <Form.Item
               label="Message"
               name="message"
               rules={[{ required: true, message: 'Please enter your message' }]}
            >
               <TextArea rows={4} placeholder="Write your message" />
            </Form.Item>

      
            <Form.Item
               name="agreement"
               valuePropName="checked"
               rules={[
                  {
                  validator: (_, value) =>
                     value ? Promise.resolve() : Promise.reject(new Error('You must agree before submitting')),
                  },
               ]}
            >
               <Checkbox>
                  <span className="light_grey">
                  I agree that my submitted data is being collected and stored.
                  </span>
               </Checkbox>
            </Form.Item>

            {/* Submit Button */}
            <Form.Item>
               <button type="primary" htmlType="submit" className="submit_btn">
                  Submit
               </button>
            </Form.Item>
            </Form>
         </div>


        </div>
       </div>
    </div>
  )
}

export default Contact
